/**
 * @module lib/commercial/sticky-ads
 * @description Multiple static advert's for a section page, and one in the standard article.
 * Which individually appear in a sticky position, in the right-rail.
 * @see https://github.com/wilddeer/stickyfill
 */
import Stickyfill from "stickyfilljs";
import tgamConfig from "config/tgam";
import { isTablet, isDesktop } from "utils/detect";
import { qsa } from "utils/utils";

export const STICKY_CLASS = "js-stickyad";
export const STICKY_SELECTOR = "." + STICKY_CLASS;

/**
 * @method setupAdvertSticky
 * @description Process all current sticky ads on the page and re-process them if they lazy load.
 * Sticky ads are only displayed on section pages, this breakpoint and up.
 * @param {String} [selector] - of the JS hook class
 * @returns {Array} of the ad sticky elements
 */
export function setupAdvertSticky(selector = STICKY_SELECTOR) {
  let ads = [];
  const validTier = isTablet("tabletWide") || isDesktop();
  const validPage = tgamConfig.meta.isSectionPage || (tgamConfig.meta.isStoryPage && !tgamConfig.meta.isStoryPremiumPage);
  if (validTier && validPage) {
    ads = qsa(selector);
    ads.forEach(ad => {
      Stickyfill.addOne(ad);
    });
    refreshStickyAll();
  }
  return ads;
}

/**
* @method refreshStickyAll
* @description Refreshes all existing stickies, updates their parameters and positions.
* All stickies are automatically refreshed after window resizes and device orientations changes.
*/
export function refreshStickyAll() {
  Stickyfill.refreshAll();
}

/**
 * @method addStickyAd
 * @description Adds the element as a sticky. Returns new Sticky instance associated with the element.
 * If there’s a sticky associated with the element, returns existing Sticky instance instead.
 * @param {HTMLElement} stickyAdUnit  - in the DOM
 */
export function addStickyAd(stickyAdUnit) {
  Stickyfill.addOne(stickyAdUnit);
}

/**
 * @method removeStickyAd
 * @description Removes sticky associated with the element.
 * @param {HTMLElement} stickyAdUnit  - in the DOM
 */
export function removeStickyAd(stickyAdUnit) {
  Stickyfill.removeOne(stickyAdUnit);
}
